/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/

import AboutIcon from './files/about.svg'
import AnalyseIcon from './files/analyse.svg'
import AromIcon from './files/arom.svg'
import BondAnyIcon from './files/bond-any.svg'
import BondAromaticIcon from './files/bond-aromatic.svg'
import BondCrossedIcon from './files/bond-crossed.svg'
import BondDative from './files/bond-dative.svg'
import BondDoubleAromaticIcon from './files/bond-doublearomatic.svg'
import BondDoubleIcon from './files/bond-double.svg'
import BondDownIcon from './files/bond-down.svg'
import BondHydrogenIcon from './files/bond-hydrogen.svg'
import BondSingleAromaticIcon from './files/bond-singlearomatic.svg'
import BondSingleDoubleIcon from './files/bond-singledouble.svg'
import BondSingleIcon from './files/bond-single.svg'
import BondTripleIcon from './files/bond-triple.svg'
import BondUpIcon from './files/bond-up.svg'
import BondUpdownIcon from './files/bond-updown.svg'
import ChainIcon from './files/chain.svg'
import ChargeMinusIcon from './files/charge-minus.svg'
import ChargePlusIcon from './files/charge-plus.svg'
import CheckIcon from './files/check.svg'
import ChiralFlagIcon from './files/chiral-flag.svg'
import CipIcon from './files/cip.svg'
import CleanIcon from './files/clean.svg'
import CopyIcon from './files/copy.svg'
import CopyImageIcon from './files/copy-image.svg'
import CopyKetIcon from './files/copy-ket.svg'
import CopyMolIcon from './files/copy-mol.svg'
import CutIcon from './files/cut.svg'
import DearomIcon from './files/dearom.svg'
import DropdownIcon from './files/dropdown.svg'
import EnhancedStereoIcon from './files/enhanced-stereo.svg'
import EraseIcon from './files/erase.svg'
import GenericGroupsIcon from './files/generic-groups.svg'
import HelpIcon from './files/help.svg'
import LayoutIcon from './files/layout.svg'
import LogoIcon from './files/logo.svg'
import MiewIcon from './files/miew.svg'
import ClearIcon from './files/clear.svg'
import OpenIcon from './files/open.svg'
import PasteIcon from './files/paste.svg'
import PeriodTableIcon from './files/period-table.svg'
import ReactionArrowBothEndsFilledTriangle from './files/reaction-arrow-both-ends-filled-triangle.svg'
import ReactionArrowDashedOpenAngle from './files/reaction-arrow-dashed-open-angle.svg'
import ReactionArrowEquilibriumFilledHalfBow from './files/reaction-arrow-equilibrium-filled-half-bow.svg'
import ReactionArrowEquilibriumFilledTriangle from './files/reaction-arrow-equilibrium-filled-triangle.svg'
import ReactionArrowEquilibriumOpenAngle from './files/reaction-arrow-equilibrium-open-angle.svg'
import ReactionArrowFailed from './files/reaction-arrow-failed.svg'
import ReactionArrowFilledBow from './files/reaction-arrow-filled-bow.svg'
import ReactionArrowFilledTriangle from './files/reaction-arrow-filled-triangle.svg'
import ReactionArrowOpenAngleIcon from './files/reaction-arrow-open-angle.svg'
import ReactionArrowUnbalancedEquilibriumFilledHalfBow from './files/reaction-arrow-unbalanced-equilibrium-filled-half-bow.svg'
import ReactionArrowUnbalancedEquilibriumFilledHalfTriangle from './files/reaction-arrow-unbalanced-equilibrium-fille-half-triangle.svg'
import ReactionArrowUnbalancedEquilibriumLargeFilledHalfBow from './files/reaction-arrow-unbalanced-equilibrium-large-filled-half-bow.svg'
import ReactionArrowUnbalancedEquilibriumOpenHalfAngle from './files/reaction-arrow-unbalanced-equilibrium-open-half-angle.svg'
import ReactionAutomapIcon from './files/reaction-automap.svg'
import ReactionMapIcon from './files/reaction-map.svg'
import ReactionPlusIcon from './files/reaction-plus.svg'
import ReactionUnmapIcon from './files/reaction-unmap.svg'
import RecognizeIcon from './files/recognize.svg'
import RedoIcon from './files/redo.svg'
import RgroupAttpointsIcon from './files/rgroup-attpoints.svg'
import RgroupFragmentIcon from './files/rgroup-fragment.svg'
import RgroupLabelIcon from './files/rgroup-label.svg'
import SaveIcon from './files/save.svg'
import SelectFragmentIcon from './files/select-fragment.svg'
import SelectLassoIcon from './files/select-lasso.svg'
import SelectRectangleIcon from './files/select-rectangle.svg'
import SettingsIcon from './files/settings.svg'
import SgroupDataIcon from './files/sgroup-data.svg'
import SgroupIcon from './files/sgroup.svg'
import ShapeEllipseIcon from './files/shape-ellipse.svg'
import ShapeLineIcon from './files/shape-line.svg'
import ShapePolylineIcon from './files/shape-polyline.svg'
import ShapeRectangleIcon from './files/shape-rectangle.svg'
import Template0Icon from './files/template-0.svg'
import Template1Icon from './files/template-1.svg'
import Template2Icon from './files/template-2.svg'
import Template3Icon from './files/template-3.svg'
import Template4Icon from './files/template-4.svg'
import Template5Icon from './files/template-5.svg'
import Template6Icon from './files/template-6.svg'
import Template7Icon from './files/template-7.svg'
import TemplateLibIcon from './files/template-lib.svg'
import TextBold from './files/text-bold.svg'
import TextIcon from './files/text.svg'
import TextItalic from './files/text-italic.svg'
import TextSubscript from './files/text-subscript.svg'
import TextSuperscript from './files/text-superscript.svg'
import TransformRotateIcon from './files/transform-rotate.svg'
import TransfromFlipHIcon from './files/transform-flip-h.svg'
import TransfromFlipVIcon from './files/transform-flip-v.svg'
import UndoIcon from './files/undo.svg'
import ZoomInIcon from './files/zoom-in.svg'
import ZoomOutIcon from './files/zoom-out.svg'
import FunctionalGroupsIcon from './files/functional-groups.svg'

const icons = {
  about: AboutIcon,
  analyse: AnalyseIcon,
  arom: AromIcon,
  'bond-any': BondAnyIcon,
  'bond-aromatic': BondAromaticIcon,
  'bond-crossed': BondCrossedIcon,
  'bond-hydrogen': BondHydrogenIcon,
  'bond-dative': BondDative,
  'bond-double': BondDoubleIcon,
  'bond-doublearomatic': BondDoubleAromaticIcon,
  'bond-down': BondDownIcon,
  'bond-single': BondSingleIcon,
  'bond-singlearomatic': BondSingleAromaticIcon,
  'bond-singledouble': BondSingleDoubleIcon,
  'bond-triple': BondTripleIcon,
  'bond-up': BondUpIcon,
  'bond-updown': BondUpdownIcon,
  chain: ChainIcon,
  'charge-minus': ChargeMinusIcon,
  'charge-plus': ChargePlusIcon,
  check: CheckIcon,
  'chiral-flag': ChiralFlagIcon,
  cip: CipIcon,
  clean: CleanIcon,
  copies: CopyIcon,
  copy: CopyIcon,
  'copy-image': CopyImageIcon,
  'copy-mol': CopyMolIcon,
  'copy-ket': CopyKetIcon,
  cut: CutIcon,
  dearom: DearomIcon,
  dropdown: DropdownIcon,
  'enhanced-stereo': EnhancedStereoIcon,
  erase: EraseIcon,
  'functional-groups': FunctionalGroupsIcon,
  'generic-groups': GenericGroupsIcon,
  help: HelpIcon,
  layout: LayoutIcon,
  logo: LogoIcon,
  miew: MiewIcon,
  clear: ClearIcon,
  open: OpenIcon,
  paste: PasteIcon,
  'period-table': PeriodTableIcon,
  'reaction-arrow-open-angle': ReactionArrowOpenAngleIcon,
  'reaction-arrow-filled-triangle': ReactionArrowFilledTriangle,
  'reaction-arrow-filled-bow': ReactionArrowFilledBow,
  'reaction-arrow-dashed-open-angle': ReactionArrowDashedOpenAngle,
  'reaction-arrow-failed': ReactionArrowFailed,
  'reaction-arrow-both-ends-filled-triangle':
    ReactionArrowBothEndsFilledTriangle,
  'reaction-arrow-equilibrium-filled-half-bow':
    ReactionArrowEquilibriumFilledHalfBow,
  'reaction-arrow-equilibrium-filled-triangle':
    ReactionArrowEquilibriumFilledTriangle,
  'reaction-arrow-equilibrium-open-angle': ReactionArrowEquilibriumOpenAngle,
  'reaction-arrow-unbalanced-equilibrium-filled-half-bow':
    ReactionArrowUnbalancedEquilibriumFilledHalfBow,
  'reaction-arrow-unbalanced-equilibrium-open-half-angle':
    ReactionArrowUnbalancedEquilibriumOpenHalfAngle,
  'reaction-arrow-unbalanced-equilibrium-large-filled-half-bow':
    ReactionArrowUnbalancedEquilibriumLargeFilledHalfBow,
  'reaction-arrow-unbalanced-equilibrium-filled-half-triangle':
    ReactionArrowUnbalancedEquilibriumFilledHalfTriangle,
  'reaction-automap': ReactionAutomapIcon,
  'reaction-map': ReactionMapIcon,
  'reaction-plus': ReactionPlusIcon,
  'reaction-unmap': ReactionUnmapIcon,
  recognize: RecognizeIcon,
  redo: RedoIcon,
  'rgroup-attpoints': RgroupAttpointsIcon,
  'rgroup-fragment': RgroupFragmentIcon,
  'rgroup-label': RgroupLabelIcon,
  save: SaveIcon,
  'select-fragment': SelectFragmentIcon,
  'select-lasso': SelectLassoIcon,
  'select-rectangle': SelectRectangleIcon,
  settings: SettingsIcon,
  'sgroup-data': SgroupDataIcon,
  sgroup: SgroupIcon,
  'template-0': Template0Icon,
  'template-1': Template1Icon,
  'template-2': Template2Icon,
  'template-3': Template3Icon,
  'template-4': Template4Icon,
  'template-5': Template5Icon,
  'template-6': Template6Icon,
  'template-7': Template7Icon,
  'template-lib': TemplateLibIcon,
  text: TextIcon,
  'text-bold': TextBold,
  'text-italic': TextItalic,
  'text-subscript': TextSubscript,
  'text-superscript': TextSuperscript,
  'transform-flip-h': TransfromFlipHIcon,
  'transform-flip-v': TransfromFlipVIcon,
  'transform-rotate': TransformRotateIcon,
  undo: UndoIcon,
  'zoom-in': ZoomInIcon,
  'zoom-out': ZoomOutIcon,
  'shape-ellipse': ShapeEllipseIcon,
  'shape-rectangle': ShapeRectangleIcon,
  'shape-polyline': ShapePolylineIcon,
  'shape-line': ShapeLineIcon
}

function emptyIcon() {
  return null
}

export default function findIconByName(name) {
  if (name && icons.hasOwnProperty(name)) {
    const component = icons[name]
    return component
  } else {
    return emptyIcon
  }
}
